import {
  MASTER_CONFIG_ITEM_LIST,
  MASTER_CONFIG_ITEM_LIST_SUCCESS,
  MASTER_CONFIG_ITEM_LIST_FAILURE,
  MASTER_CONFIG_ITEM_CREATE,
  MASTER_CONFIG_ITEM_CREATE_SUCCESS,
  MASTER_CONFIG_ITEM_CREATE_FAILURE,
  MASTER_CONFIG_ITEM_UPDATE,
  MASTER_CONFIG_ITEM_UPDATE_SUCCESS,
  MASTER_CONFIG_ITEM_UPDATE_FAILURE,
} from "./actionType";

const initialState = {
  // LIST
  masterConfigItemList: [],
  masterConfigItemListLoading: false,
  masterConfigItemListError: null,

  // CREATE
  masterConfigItemCreate: {},
  masterConfigItemCreateLoading: false,
  masterConfigItemCreateError: null,

  // UPDATE
  masterConfigItemUpdate: {},
  masterConfigItemUpdateLoading: false,
  masterConfigItemUpdateError: null,
};

const masterConfigItemReducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case MASTER_CONFIG_ITEM_LIST:
      return {
        ...state,
        masterConfigItemListLoading: true,
        masterConfigItemListError: null,
      };
    case MASTER_CONFIG_ITEM_LIST_SUCCESS:
      return {
        ...state,
        masterConfigItemList: action.payload,
        masterConfigItemListLoading: false,
      };
    case MASTER_CONFIG_ITEM_LIST_FAILURE:
      return {
        ...state,
        masterConfigItemListLoading: false,
        masterConfigItemListError: action.payload,
      };

    // CREATE
    case MASTER_CONFIG_ITEM_CREATE:
      return {
        ...state,
        masterConfigItemCreateLoading: true,
        masterConfigItemCreateError: null,
      };
    case MASTER_CONFIG_ITEM_CREATE_SUCCESS:
      return {
        ...state,
        masterConfigItemCreate: action.payload,
        masterConfigItemCreateLoading: false,
      };
    case MASTER_CONFIG_ITEM_CREATE_FAILURE:
      return {
        ...state,
        masterConfigItemCreateLoading: false,
        masterConfigItemCreateError: action.payload,
      };

    // UPDATE
    case MASTER_CONFIG_ITEM_UPDATE:
      return {
        ...state,
        masterConfigItemUpdateLoading: true,
        masterConfigItemUpdateError: null,
      };
    case MASTER_CONFIG_ITEM_UPDATE_SUCCESS:
      return {
        ...state,
        masterConfigItemUpdate: action.payload,
        masterConfigItemUpdateLoading: false,
      };
    case MASTER_CONFIG_ITEM_UPDATE_FAILURE:
      return {
        ...state,
        masterConfigItemUpdateLoading: false,
        masterConfigItemUpdateError: action.payload,
      };

    default:
      return state;
  }
};

export default masterConfigItemReducer;
